// noinspection ES6PreferShortImport
import axios from 'axios';
import {cacheAdapterEnhancer, throttleAdapterEnhancer} from 'axios-extensions';
import LRUCache from 'lru-cache';
import {getActualPublicToken, getToken} from '../utilities/utilitiesToken';

export const BASE_URL_TYPE = {
  PROPZONE: process.env.REACT_APP_SETTINGS_URL,
  API: process.env.REACT_APP_API_URL,
  TILES_CDN: process.env.REACT_APP_DYNAMIC_TILES_URL,
  RAPI: process.env.REACT_APP_RAPI_URL,
  USER: process.env.REACT_APP_ACCOUNTS_SITE,
};

const getAxiosInstance = (
  urlType = BASE_URL_TYPE.PROPZONE,
  noToken = false,
  skipCaching = false,
) => {
  const config = {
    baseURL: urlType || '',
    timeout: 60 * 1000 * 10,
    // withCredentials: true,
  };
  if (!skipCaching) {
    config.adapter = throttleAdapterEnhancer(cacheAdapterEnhancer(axios.getAdapter(axios.defaults.adapter)), {
      // Default is new LRUCache({maxAge: 1000 * 60 * 5, max: 100}).
      defaultCache: new LRUCache({ttl: 1000 * 60 * 30, max: 100}),
    });
  }
  const axiosInstance = axios.create(config);

  // Add a request interceptor
  axiosInstance.interceptors.request.use(
    async (requestConfig) => {
      if (noToken) {
        return requestConfig;
      }

      const headers = {...requestConfig.headers};
      const requestUrl = new URL(requestConfig.url);
      const params = new URLSearchParams(requestUrl.searchParams);

      if (params.has('publicToken')) {
        const publicToken = params.get('publicToken');
        if (publicToken) {
          const token = await getActualPublicToken();
          params.set('publicToken', token);
        }
      }

      if (requestConfig.data?.publicToken) {
        const {publicToken} = requestConfig.data;
        if (publicToken) {
          requestConfig.data = await getActualPublicToken();
        }
      }

      if (requestConfig.data?.get && requestConfig.data?.get('publicToken')) {
        const publicToken = requestConfig.data?.get('publicToken');
        if (publicToken) {
          const token = await getActualPublicToken();
          // eslint-disable-next-line no-unused-expressions
          requestConfig.data?.set('publicToken', token);
        }
      }
      let withCredentials;

      if (requestUrl.origin.indexOf(BASE_URL_TYPE.PROPZONE) > -1) {
        headers['X-CSRF-Token'] = getToken();
        withCredentials = true;
      }

      return {
        ...requestConfig,
        url: `${requestUrl.origin}${requestUrl.pathname}?${params.toString()}${requestUrl.hash}`,
        headers,
        withCredentials,
        mode: 'no-cors',
      };
    },
    error => Promise.reject(error),
  );
  // Add a response interceptor
  axiosInstance.interceptors.response.use(
    response => response,
    error => Promise.reject(error),
  );

  axiosInstance.isCancel = err => axios.isCancel(err);

  return axiosInstance;
};

export default getAxiosInstance;
